export const ar = {
    //home page

    downloadResume: "تنزيل السيرة الذاتية",
    loadMoreProducts: "المزيد من المنتجات",
    readMoreReviews: "المزيد من التعليقات",
    moreAboutUs: "مزيد من المعلومات حولنا",
    Result: "تحقيق النتائج مع",
    Digital: "رقمي",
    Solution: "حلول",
    provide: "نحن نقدم حلولًا إبداعية وتقنية للشركات للانخراط مع جمهورها المستهدف من خلال القنوات الرقمية",
    ourServices: "خدماتنا",
    ServicesText: "لوريم إيبسوم هو نص وهمي يُ ستخدم في صناعة الطباعة والتصميم الجرافيكي.",
    TopProducts: "أفضل المنتجات ",
    CustomerFeedback: "آراء العملاء",
    CustomerText: "لوريم إيبسوم هو نص وهمي يُ ستخدم في صناعة الطباعة والتصميم الجرافيكي.يُ ستخدم هذا النص لملء الفراغات.لوريم إيبسوم هو نص وهمي يُ ستخدم في صناعة الطباعة والتصميم الجرافيكي...",
    role: "الاسم.الدور ",
    textAboutUs: "بدأت شركة نوا في عام 2017  برقم تسجيل 16154778. قام مؤسسو هذه الشركة، الذين لديهم أكثر من عشر سنوات من الخبرة في البرمجة وبيئة الشركات الناشئة في البلاد، بإنشائها بناءً على تجاربهم وتجارب الآخرين.",
    OurProcess: "عمليتنا",
    OurTrustedPartner: "عملائنا",
    Explore: "اكتشف أفكار عملك من خلال استراتيجياتنا الحديثة",
    team: "فريقنا مستعد لمساعدتك في تحقيق أهداف عملك من خلال استراتيجيات التسويق الرقمي الإبداعية والحديثة.",
    Certification: "شهادة",
    Description: "الوصف",
    text3: "ما هو التسويق الرقمي ولماذا هو مهم لشركتك؟ لوريم إيبسوم هو نص وهمي يُستخدم في صناعة الطباعة والتصميم الجرافيكي. يُستخدم هذا النص لملء الفراغات. لوريم إيبسوم هو نص وهمي يُستخدم في صناعة الطباعة والتصميم الجرافيكي...",
    Blogs: "المدونات",
    Marketing: "التسويق",
    readMore: "اقرأ المزيد ",
    labelName: "الاسم الأول",
    labelLastName: "الاسم الثانی",
    labelEmail: "بريد إلكتروني",
    labelNumber: "رقمک",
    //header,
    Home: "البیت",
    Products: "المنتجات",
    Projects: "المشاريع",
    AboutUs: "معلومات عنا",
    ContactUs: "اتصل بنا",
    ChangeLang: "تغيير اللغة إلى",
    Farsi: "الإنجليزية",
    SwitchMode: "تغيير الخلفية إلى",
    darkMode: "الوضع الداكن",
    lightMode: "الوضع الفاتح",
    lng: "ع",
    // footer
    footerText: `نوفا شركة تقنية رائدة، متخصصة في تطوير برمجيات الويب والهواتف المحمولة. خبرتنا الأساسية تكمن في تصميم وتطوير تطبيقات عالية الجودة لنظامي iOS وAndroid، بالإضافة إلى مواقع إلكترونية متطورة مصممة خصيصًا لمواكبة التطور الرقمي.

        في نوفا، لسنا مجرد مطورين، بل نحن مبدعون ومبتكرون ونقدم حلولً ا للمشاكل.نسعى جاهدين لتجسيد أفكار جديدة، ونعمل عن كثب مع الشركات الناشئة والشركات التجارية لتصميم منتجات رقمية فريدة وسهلة الاستخدام وفعالة.
    `,
    QuickLinks: "روابط سريعة",
    Support: "الدعم",
    allJob: "الفرص الوظيفية",
    Address: "العنوان",
    // about us
    aboutTitle: "شركة نوا",
    aboutDescription: "شركة نوا، نؤمن بقوة التسويق الرقمي ونساعدك في رفع علامتك التجارية إلى القمة باستخدام استراتيجيات جديدة. منذ تأسيسنا في عام 2019، كان هدفنا تقديم حلول مبتكرة وفعالة في العالم الرقمي. مع فريق من الخبراء وتجارب ناجحة في مجالات متعددة، نساعدك على التميز عبر الإنترنت.",
    OurMission: "مهمتنا",
    OurMissionDescription: "مهمتنا هي تعزيز العلامات التجارية والأعمال من خلال استراتيجيات حديثة ومبدعة.نساعدك في تحقيق أهداف عملك باستخدام التكنولوجيا والابتكارات الرقمية.",
    companyVision: "رؤية الشركة",
    companyVisionDescription: "حالياً، خطة الشركة تركز على تطوير المنتجات الخارجية (التطبيقات والمواقع الإلكترونية) والتركيز على مجالات الذكاء الاصطناعي وتنفيذ مشاريع الأتمتة الداخلية.",
    Awards: "الجوائز والتكريمات",
    AwardsDescription2018: "المرشح النهائي لأفضل تطبيق في مهرجان إيران للتطبيقات والهواتف المحمولة في عام 2018",
    AwardsDescription1400: "المرشح النهائي لأفضل مشروع في مهرجان مقاطعة أب كانتري عام 1400",
    // job
    JobOpportunities: "فرص العمل",
    designer: "مصمم واجهات وتجربة مستخدم",
    ago: "منذ يومين",
    JobText: "لوريم إيبسوم هو نص وهمي يُستخدم في صناعة الطباعة والتصميم الجرافيكي. يُستخدم هذا النص لملء الفراغات. لوريم إيبسوم هو نص وهمي يُستخدم في صناعة الطباعة والتصميم الجرافيكي...",
    open: "متاح",
    pending: "قيد الانتظار",
    closed: "مغلق",
    palaseHolderName: "أدخل اسمك الأول",
    palaseHolderFamily: "أدخل اسمك الأخير",
    palaseHolderEmail: "أدخل بريدك الإلكتروني",
    palaseHolderPhone: "رقم هاتفك",
    JobDescription: "وصف الوظيفة",
    CV: "تحميل السيرة الذاتية",
    Upload: "تحميل الملف",
    Max: "الحد الأقصى لحجم الملف 30 ميجا بايت!",
    send: "يرسل",
    sending: "إرسال...",

    // محصولات
    uiUxDesign: "الجميع",
    uiUxDesign1: "تصميم واجهات وتجربة مستخدم",
    uiUxDesign2: "تطوير الويب",
    uiUxDesign3: "تطوير التطبيقات",
    irangardi: "إيرانجردي",
    moreInformation: "مزيد من المعلومات",
    productText: "لوريم إيبسوم هو نص وهمي يُستخدم في صناعة الطباعة والتصميم الجرافيكي. يُستخدم هذا النص لملء الفراغات. لوريم إيبسوم هو نص وهمي يُستخدم في صناعة الطباعة والتصميم الجرافيكي...",
    Load: "تحميل المزيد من الوظائف",
    loadMoreProjects: "تحميل المزيد من المشاريع",
    TopFeatures: "أهم الميزات",
    OtherFeatures: "ميزات أخرى",

    // contact us
    Message: "رسالتك",
    Message2: "أدخل رسالتك",
    address: "التواصل عبر الموقع",
    email: "التواصل عبر البريد الإلكتروني",
    phone: "التواصل عبر الهاتف",
    whatsapp: "التواصل عبر الواتساپ",
    phoneNumber: " +44 7572 079872",
    phoneRequired: "الرجاء إدخال رقم هاتفك",
    fileRequired: "اضغط على خيار التحديد",
    textRequired: "تم إدخال النص",
    phoneInvalid: "رقم الهاتف المدخل غير صالح",
    emailRequired: "الرجاء إدخال عنوان بريدك الإلكتروني",
    emailInvalid: "تنسيق البريد الإلكتروني غير صحيح",
    nameRequired: "الرجاء إدخال اسمك الأول",
    lastNameRequired: "الرجاء إدخال اسم العائلة",
    messageRequired: "الرجاء إدخال رسالتك",
    SuccessMessage: "تم تسجيل المعلومات بنجاح",
    errorMessage: "حدث خطأ",
    errorServerMessage: "حدث خطأ في الخادم",
    Loading: "تحميل...",
    //detail product
    visitWebsite: "زيارة الموقع",
    take: "ألق نظرة على جمال السفر إلى إيران! قم بزيارة موقعنا الآن!",
    Discover: "اكتشف عالم الجمال من خلال تنزيل تطبيق ایرانگردی",
    downloadApplication: "تنزيل التطبيق",
    btnMoreBlog: "تحميل المزيدالمدونة",
    Introduction: "مقدمة المنتج",
    TechnicalDetails: "التفاصيل الفنية",
    relatedPosts: "المدونات ذات الصلة",

};